// modules
import { handleActions } from 'redux-actions'

// actions
import {
  setMedicalDeviceManagementList,
  resetMedicalDeviceManagement
} from 'src/store/modules/actions/medicalDeviceManagement'

const initialState = {
  medicalDeviceManagementList: []
}

export default handleActions(
  {
    [setMedicalDeviceManagementList](
      state,
      { payload: medicalDeviceManagementList }
    ) {
      return {
        ...state,
        medicalDeviceManagementList
      }
    },

    [resetMedicalDeviceManagement]() {
      return initialState
    }
  },
  initialState
)
